import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-neutral-950 text-neutral-400 py-12 px-4 border-t border-neutral-800" data-id="element-39">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-40">
          <div className="text-sm" data-id="element-41">
            &copy; {new Date().getFullYear()} Settle-In Anywhere Kit. All rights
            reserved.
          </div>
          <div className="flex gap-6 text-sm" data-id="element-42">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-43">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-44">
              Terms of Service
            </button>
            <a href="mailto:hello@settleinanywhere.com" className="hover:text-white transition-colors" data-id="element-45">
              Contact
            </a>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-46">
        <p className="text-neutral-500 text-xs" data-id="element-47">Last updated: February 2026</p>

        <h3 className="font-bold text-neutral-900 text-base mt-2" data-id="element-48">
          1. Information We Collect
        </h3>
        <p data-id="element-49">
          When you purchase the 14-Day Settle-In Anywhere Kit, we collect only
          the information necessary to process your order: your name, email
          address, and payment details. Payment is processed securely through
          Stripe — we never store your credit card information on our servers.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-50">
          2. How We Use Your Information
        </h3>
        <p data-id="element-51">
          We use your email address solely to deliver your purchase and send
          important updates about the product. We do not sell, rent, or share
          your personal information with third parties for marketing purposes.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-52">
          3. Cookies & Analytics
        </h3>
        <p data-id="element-53">
          Our website may use basic analytics cookies to understand how visitors
          interact with our pages. These cookies do not collect personally
          identifiable information. You can disable cookies in your browser
          settings at any time.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-54">
          4. Data Security
        </h3>
        <p data-id="element-55">
          We implement industry-standard security measures to protect your
          personal information. All data transmission is encrypted using SSL/TLS
          technology.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-56">5. Your Rights</h3>
        <p data-id="element-57">
          You have the right to access, correct, or delete your personal data at
          any time. To exercise these rights, contact us at
          hello@settleinanywhere.com. We will respond to your request within 30
          days.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-58">
          6. Changes to This Policy
        </h3>
        <p data-id="element-59">
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated revision date. Your continued
          use of our services constitutes acceptance of the updated policy.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-60">7. Contact</h3>
        <p data-id="element-61">
          If you have any questions about this Privacy Policy, please contact us
          at{' '}
          <a href="mailto:hello@settleinanywhere.com" className="text-amber-700 underline" data-id="element-62">
            hello@settleinanywhere.com
          </a>
          .
        </p>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-63">
        <p className="text-neutral-500 text-xs" data-id="element-64">Last updated: February 2026</p>

        <h3 className="font-bold text-neutral-900 text-base mt-2" data-id="element-65">
          1. Overview
        </h3>
        <p data-id="element-66">
          By purchasing and using the 14-Day Settle-In Anywhere Kit ("the
          Product"), you agree to be bound by these Terms of Service. The
          Product is a digital information kit designed to help newcomers
          navigate their first days in a new country.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-67">
          2. Digital Product Delivery
        </h3>
        <p data-id="element-68">
          Upon successful payment, you will receive immediate access to the
          Product via email. The Product is delivered in digital format (PDF,
          templates, and checklists). You are granted a personal,
          non-transferable license to use the materials.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-69">
          3. Refund Policy
        </h3>
        <p data-id="element-70">
          We offer a 30-day money-back guarantee. If you are not satisfied with
          the Product for any reason, contact us within 30 days of purchase for
          a full refund. No questions asked.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-71">
          4. Intellectual Property
        </h3>
        <p data-id="element-72">
          All content within the Product — including text, templates, scripts,
          checklists, and design — is protected by copyright. You may not
          reproduce, distribute, or resell any part of the Product without
          written permission.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-73">5. Disclaimer</h3>
        <p data-id="element-74">
          The Product provides general guidance and informational tools. It does
          not constitute legal, financial, or immigration advice. We are not
          responsible for decisions made based on the information provided.
          Always consult qualified professionals for specific legal or financial
          matters.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-75">
          6. Limitation of Liability
        </h3>
        <p data-id="element-76">
          To the maximum extent permitted by law, our total liability for any
          claims arising from the use of the Product shall not exceed the amount
          you paid for it.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-77">
          7. Changes to Terms
        </h3>
        <p data-id="element-78">
          We reserve the right to modify these Terms at any time. Changes take
          effect immediately upon posting. Continued use of the Product after
          changes constitutes acceptance.
        </p>

        <h3 className="font-bold text-neutral-900 text-base" data-id="element-79">8. Contact</h3>
        <p data-id="element-80">
          For questions about these Terms, contact us at{' '}
          <a href="mailto:hello@settleinanywhere.com" className="text-amber-700 underline" data-id="element-81">
            hello@settleinanywhere.com
          </a>
          .
        </p>
      </Modal>
    </>;
}